import { Button, ContentTemplate, Grid } from 'web-library';
import React from 'react';
import { ViewSelectedSubjectsResponseBody } from '../../api/candidate/exam/model';
import ExamDraftMessage from '../../modules/examRegistration/components/ExamDraftMessage';

export interface INavigation {
  label: string;
  onRouting: any;
}

interface ISelectAddSubjectsNavButton {
  backNavigation: INavigation;
  toNavigation: INavigation;
  enable?: boolean;
  examTypeCode: string;
  selectedSubjectsData: ViewSelectedSubjectsResponseBody[];
}

const SelectAddSubjectsNavButtons = ({
  enable,
  backNavigation,
  toNavigation,
  examTypeCode,
  selectedSubjectsData,
}: ISelectAddSubjectsNavButton) => {
  const { label: backNavLabel, onRouting: backNavRouting } = backNavigation;
  const { label: toNavLabel, onRouting: toNavRouting } = toNavigation;

  return (
    <ContentTemplate continuous>
      <Grid container direction="row" alignItems="flex-start" spacing={3}>
        <Grid xs={12} md={3}>
          <Button
            fullWidth
            type="button"
            color="secondary"
            variant="outlined"
            onClick={() => backNavRouting(examTypeCode)}
          >
            {backNavLabel}
          </Button>
        </Grid>
        <Grid xs={12} md={5}>
          {!enable && (
            <Button
              fullWidth
              type="button"
              color="secondary"
              id="button-next-page"
              disabled={!selectedSubjectsData || selectedSubjectsData.length < 1}
              onClick={toNavRouting}
            >
              {toNavLabel}
            </Button>
          )}
          {enable && (
            <Button
              fullWidth
              type="button"
              color="secondary"
              id="button-next-page"
              onClick={toNavRouting}
            >
              {toNavLabel}
            </Button>
          )}
        </Grid>
      </Grid>
      <ExamDraftMessage />
    </ContentTemplate>
  );
};

export default SelectAddSubjectsNavButtons;
